import { render, staticRenderFns } from "./SalEditor.vue?vue&type=template&id=5aa78f41"
import script from "./SalEditor.vue?vue&type=script&lang=js"
export * from "./SalEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports